import { E164Number, parsePhoneNumberFromString } from 'libphonenumber-js/min';

function getPhoneNumber(phoneNumber: string | number, phoneCountry: string): E164Number | string | undefined {
    phoneNumber = phoneNumber.toString();
    phoneNumber = phoneNumber.replace(/\s/g, '');
    // Handle phone number
    let phone;
    const phoneNumberFirstChar = phoneNumber.substr(0, 1);
    if (phoneNumberFirstChar === '+') {
        // User typped an international phone number, no need to merge country code and phone number.
        phone = phoneNumber;
    } else {
        const parsed = parsePhoneNumberFromString(phoneCountry + phoneNumber);
        if (parsed) {
            phone = parsed.number;
        }
    }
    return phone;
}

function getCountryCallingCodeByPhoneNumber(phoneNumber: string) {
    // Handle country calling code
    let countryCallingCode;
    const parsed = parsePhoneNumberFromString(phoneNumber);
    if (parsed) {
        countryCallingCode = `+${parsed.countryCallingCode}`;
    }
    return countryCallingCode;
}

export type ParsePhoneReturn = {
    getPhoneNumber: Function;
    getCountryCallingCodeByPhoneNumber: Function;
};

export const parsePhone = (): ParsePhoneReturn => {
    return {
        getPhoneNumber,
        getCountryCallingCodeByPhoneNumber,
    };
};
